export const styles = () => ({
  moreIcon: {
    marginLeft: 6
  }
})



// WEBPACK FOOTER //
// ./src/components/WaitingPassengerOptions/styles.js